import React from 'react';
import './IVRCrumbs.css';


const button = {
  padding: '0'
}

const Breadcrumb = (props) => {
  let ivrAttributes = props['attributePack']['crumbsList'].toString().split('>').reverse();
  const copyCodeToClipboard = (ci) => {
    if (ci === -1) {
      let crumbArray = []
      ivrAttributes.forEach((crumbs) => {
        let timeStamp = [];
        let crumbLineLevelArray = [];
        crumbs.split('^').forEach((crumb, index) => {
          if (index === 0) {
            timeStamp.push(crumb)
          } else if ((index === 1) && crumb.includes('FAILURE')) {
            let crumbLine = crumb.toString().split(':')[1]
            crumbLineLevelArray.push(crumbLine)
          } else {
            crumbLineLevelArray.push(crumb)
          }
        })
        let crumbLineLevel = (crumbLineLevelArray.join('/'));
        timeStamp.push(crumbLineLevel);
        let crumbswithTimeStamp = timeStamp.join(' ')
        crumbArray.push(crumbswithTimeStamp)
      })
      let crumbsToCopy = crumbArray.join('\n')
      navigator.clipboard.writeText(crumbsToCopy)
    }

    else {
      let crumbArray = [];
      ivrAttributes.forEach((crumbs, i) => {
        if (ci === i) {
          let timeStamp = [];
          let crumbLineLevelArray = [];
          crumbs.split('^').forEach((crumb, index) => {
            if (index === 0) {
              timeStamp.push(crumb)
            } else if ((index === 1) && crumb.includes('FAILURE')) {
              let crumbLine = crumb.toString().split(':')[1]
              crumbLineLevelArray.push(crumbLine)
            } else {
              crumbLineLevelArray.push(crumb)
            }
          })
          let crumbLineLevel = (crumbLineLevelArray.join('/'));
          timeStamp.push(crumbLineLevel);
          let crumbswithTimeStamp = timeStamp.join(' ')
          crumbArray.push(crumbswithTimeStamp)
        }
      })

      navigator.clipboard.writeText(crumbArray)
    }
  }

  let crumbs = props['attributePack']['crumbsList']


  return (
    <>
    {
      crumbs.length === 0 ? <div className="no-breadcrumb">
        <em>No Crumbs</em>
      </div> :
        <div id="myInput">
          <div className="center">
            <button  type="button" className="copyall-button" onClick={ () => copyCodeToClipboard(-1) }>
              Copy All
              <img className = "img" src="https://img.icons8.com/material/20/000000/copy--v1.png" alt="" />
            </button>
          </div>
          <i className="icon-copy"></i>
          <div className="crumbs-list">
            {ivrAttributes.map((crumbs, i) => {
              return (
                <li className="all-breadcrumb-item" key ={crumbs}>
                  {
                    crumbs.split('^').map((crumb, index) => {
                      if (index === 0) {
                        return (
                          <span className="breadcrumb-timestamp" key = {crumb}>{crumb} </span>
                        )
                      }
                      if ((index === 1) && crumb.includes('FAILURE')) {
                        return (
                          <span className="breadcrumb-error-item" key = {crumb}>{crumb.toString().split(':')[0]} - {crumb.toString().split(':')[1]} /</span>
                        )
                      }
                      return (
                        <span className="breadcrumb-item" key = {crumb} > {crumb}</span>
                      );
                    })
                  }
                  <span className ="right">
                    <button type="button" className="copy-button" onClick={ () => copyCodeToClipboard(i) } >
                      <img src="https://img.icons8.com/material/15/000000/copy--v1.png" alt=""/>
                    </button>
                  </span>
                </li>
              )
            })
            }
          </div>
        </div>
    }
    </>
  );
}

export default Breadcrumb;